import React, { useState, useEffect } from 'react';
import { 
  Typography, 
  Slider, 
  TextField, 
  Button, 
  Card, 
  CardContent,
  Grid,
  Box,
  Paper,
  Link,
  InputAdornment
} from '@mui/material';

const BCBACalculator = () => {
  const [bcbas, setBcbas] = useState(10);
  const [hoursPerMonth, setHoursPerMonth] = useState(16);
  const [hourlyRate, setHourlyRate] = useState(50);
  const [indirectHours, setIndirectHours] = useState(0);
  const [totalRevenue, setTotalRevenue] = useState(0);

  useEffect(() => {
    const calculatedIndirectHours = bcbas * hoursPerMonth;
    setIndirectHours(calculatedIndirectHours);

    const calculatedRevenue = bcbas * hoursPerMonth * 12 * hourlyRate;
    setTotalRevenue(calculatedRevenue);
  }, [bcbas, hoursPerMonth, hourlyRate]);

  const handleHourlyRateChange = (event) => {
    const value = event.target.value.replace(/^0+/, '');
    setHourlyRate(value === '' ? 0 : Number(value));
  };

  return (
    <Paper elevation={3} sx={{ p: 3, backgroundColor: 'background.default' }}>
      <Grid container spacing={4}>
        <Grid item xs={12} md={5}>
          <Card elevation={2}>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                # of BCBAs
              </Typography>
              <Slider
                value={bcbas}
                onChange={(_, newValue) => setBcbas(newValue)}
                min={1}
                max={50}
                valueLabelDisplay="auto"
              />
              <Typography variant="body1" align="center">
                {bcbas}
              </Typography>

              <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
                Non-billable Hours per BCBA per month for parent training
              </Typography>
              <Slider
                value={hoursPerMonth}
                onChange={(_, newValue) => setHoursPerMonth(newValue)}
                min={1}
                max={40}
                valueLabelDisplay="auto"
              />
              <Typography variant="body1" align="center">
                {hoursPerMonth}
              </Typography>

              <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
                Avg. BCBA Hourly Rate
              </Typography>
              <TextField
                type="text"
                value={hourlyRate}
                onChange={handleHourlyRateChange}
                fullWidth
                InputProps={{
                  startAdornment: <InputAdornment position="start">$</InputAdornment>,
                }}
                inputProps={{
                  inputMode: 'numeric',
                  pattern: '[0-9]*'
                }}
              />
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} md={7}>
          <Card elevation={2} sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
            <CardContent sx={{ flexGrow: 1 }}>
              <Typography variant="h6" gutterBottom>
                Indirect Hours Saved per Month
              </Typography>
              <Typography variant="h2" color="primary" align="center" sx={{ mb: 4 }}>
                {indirectHours}
              </Typography>

              <Typography variant="h6" gutterBottom>
                Annual Revenue Potential
              </Typography>
              <Typography variant="h2" color="secondary" align="center" sx={{ mb: 4 }}>
                ${totalRevenue.toLocaleString()}
              </Typography>
            </CardContent>
            <Box sx={{ p: 3 }}>
              <Button 
                variant="contained" 
                color="secondary" 
                fullWidth 
                size="large"
                component={Link}
                href="https://www.joonhealth.co/company/demo-aba"
                target="_blank"
                rel="noopener noreferrer"
              >
                Schedule a free demo
              </Button>
            </Box>
          </Card>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default BCBACalculator;